import { Avatar, AvatarGroup, Badge, Grid, styled } from "@mui/material";
import HCheckArray from "@rf-helper/check-have-value";
import { SvgBackgroundWrapper } from "@rf-l1/animated/SvgBackgroundWrapper";
import MxIcons from "@rf-l1/MxIcons";
import MxTypography from "@rf-l1/MxTypography";
import MxTooltipContent from "@rf-l1/tooltip/MxTooltipContent";
import { agentAutoCompleteItem } from "@rf/adapters/autocomplete-items/agentItemAdapters";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { IconCircleXFilled } from "@tabler/icons-react";
import { useMemo } from "react";
import { useController, useWatch } from "react-hook-form";

const AgentsGroupSelected = () => {
  const [brokers_property] = useWatch({
    name: [CPropertyFormKeys.brokers_property]
  });

  const { field } = useController({
    name: CPropertyFormKeys.brokers_property
  });

  const agentsSelected = useMemo(() => {
    if (HCheckArray(brokers_property)) {
      // Keep the visual order consistent with saved array order
      return brokers_property.slice() as agentAutoCompleteItem[];
    } else {
      return [] as agentAutoCompleteItem[];
    }
  }, [JSON.stringify(brokers_property)]);

  const handleDeleteAgent = (id: number) => {
    if (id) {
      const newState = brokers_property.filter(
        (broker: agentAutoCompleteItem) => broker.value != id
      );
      field.onChange(newState);
    }
  };

  if (!HCheckArray(brokers_property) || brokers_property?.length == 0) return <></>;

  return (
    <Grid item xs="auto">
      <ContentBrokerList>
        <AvatarGroup max={4}>
          {agentsSelected.map((broker: agentAutoCompleteItem, i) => (
            <MxTooltipContent key={broker.id} template={<InfoAgents {...broker} />}>
              <DeleteBadge
                overlap="circular"
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                badgeContent={
                  <SvgBackgroundWrapper padding={0.5}>
                    <MxIcons
                      size={24}
                      color="red"
                      onClick={() => handleDeleteAgent(broker.id)}
                      key={broker.id}
                    >
                      <IconCircleXFilled className="icon" />
                    </MxIcons>
                  </SvgBackgroundWrapper>
                }
              >
                <Avatar
                  alt={broker.label}
                  key={broker.value}
                  src={broker?.extraData?.agentData.picture ?? ""}
                  sx={{
                    filter: broker?.extraData?.agentData.isSuspend
                      ? "grayscale(100%)"
                      : "none"
                  }}
                />
              </DeleteBadge>
            </MxTooltipContent>
          ))}
        </AvatarGroup>
      </ContentBrokerList>
    </Grid>
  );
};

const InfoAgents = (props: agentAutoCompleteItem) => {
  return (
    <Grid
      maxWidth={200}
      container
      sx={{
        display: "grid",
        alignItems: "center",
        gridTemplateColumns: "auto 1fr",
        columnGap: 1,
        filter: props.extraData?.agentData.isSuspend ? "grayscale(100%)" : "none"
      }}
    >
      <Grid item width={40}>
        <Avatar
          sx={{ width: 40, height: 40 }}
          alt={props.label}
          key={props.value}
          src={props?.extraData?.agentData.picture ?? ""}
        />
      </Grid>
      <Grid container alignItems={"center"} justifyContent={"center"}>
        <Grid item xs={12}>
          <MxTypography
            textAlign="center"
            color="primary.main"
            variant="caption"
            fontWeight={600}
            children={props.extraData?.agentData.name ?? ""}
            lines={1}
          />
        </Grid>
        <Grid item xs={12}>
          <MxTypography
            textAlign="center"
            color="gray"
            variant="overline"
            fontWeight={500}
            children={props.extraData?.agentData.agencyName ?? ""}
            lines={1}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

const ContentBrokerList = styled("div")(({ theme }) => ({
  display: "flex",
  marginLeft: "20px",
  "& .MuiAvatar-root": {
    border: `1px solid ${theme.palette.common.white}`, // Uso de color del tema
    marginLeft: "-12px"
  }
}));

const DeleteBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    opacity: 0,
    transition: "opacity 0.2s"
  },
  "&:hover .MuiBadge-badge": {
    opacity: 1
  }
}));
export default AgentsGroupSelected;
